import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { WhatsAppFloating } from "./WhatsAppFloating";
import { ReactNode, memo } from "react";
import { GlobalErrorBoundary } from "./GlobalErrorBoundary";

interface LayoutProps {
  children: ReactNode;
}

/**
 * High-Scale Core Layout Wrapper
 * Implements Error Boundary and consistent shell architecture
 */
export const Layout = memo(({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-[#0a0c10] text-foreground selection:bg-electric/30 selection:text-white">
      <Nav />
      <GlobalErrorBoundary>
        {children}
      </GlobalErrorBoundary>
      <Footer />
      <WhatsAppFloating />
    </div>
  );
});

Layout.displayName = "Layout";
